import React, { useEffect, useState } from "react";
import Navbar from "../../Homepage/Navbar/Navbar";
import "./raindetail.scss";
import { Link, useParams } from "react-router-dom";
import { useTheme } from "../../../contexts/ThemeProvider";
import Footer from "../../Homepage/footer/Footer";
import { Breadcrumb } from "react-bootstrap";
import appsData from "./appsdata";

const Raindetailpage = () => {

  const { id } = useParams();
  const app = appsData.find((item) => item.id === id);

  const { theme, toggle } = useTheme();

  useEffect(() => {
    if (theme !== "dark") toggle();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    document.body.classList.add("home-page-body");
    return () => {
      document.body.classList.remove("home-page-body");
    };
  }, []);

  const [activeIndex, setActiveIndex] = useState(0);

  if (!app) return null;

  const nextSlide = () => {
    setActiveIndex((prev) => (prev + 1) % app.images.length);
  };

  const prevSlide = () => {
    setActiveIndex((prev) =>
      prev === 0 ? app.images.length - 1 : prev - 1
    );
  };

  return (
    <>
      <Navbar />

      <section className="mainside-detail">
        <div className="custom-container">

          <Breadcrumb className="common-breadcrumbs">
            <Breadcrumb.Item href="/apps">Apps</Breadcrumb.Item>
            <Breadcrumb.Item active>{app.name}</Breadcrumb.Item>
          </Breadcrumb>

          <div className="inner-side-detail">

            {/* LEFT SIDE */}
            <div className="leftsidedetail">

              <div className="leftinnner">

                <img src={app.shade} className="appshade" />

                <div className="lefttop">
                  <div className="logomain">
                    <img src={app.logo} alt="logo" />
                  </div>

                  <h2 style={app.id === 'black-jack' ? { background: "rgba(133, 89, 227, 0.20)", color: "#8559E3" } : {}}>{app.category}</h2>
                  <h3>{app.name}</h3>

                  <h4>
                    by:<span>{app.creator}</span>

                  </h4>

                </div>

                <div className="leftsidenew">
                  {
                    app.twitter != "" && (
                      <div className="linksocials">
                        <a target="blank" href={app.twitter}>
                          <img src="/assets/xx.svg" />
                        </a>
                      </div>
                    )
                  }


                  <Link to={app.visitLink} target="_blank" rel="noopener noreferrer">
                    <button>
                      Visit App
                      {/* SVG unchanged */}
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <path d="M15.75 9.75V14.25C15.75 14.6478 15.592 15.0294 15.3107 15.3107C15.0294 15.592 14.6478 15.75 14.25 15.75H3.75C3.35218 15.75 2.97064 15.592 2.68934 15.3107C2.40804 15.0294 2.25 14.6478 2.25 14.25V3.75C2.25 3.35218 2.40804 2.97064 2.68934 2.68934C2.97064 2.40804 3.35218 2.25 3.75 2.25H8.25" stroke="#151515" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M15.75 2.25L9 9" stroke="#151515" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M11.25 2.25H15.75V6.75" stroke="#151515" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </button>
                  </Link>

                </div>
              </div>

              {/* Elevator Pitch */}
              <div className="leftmiddle">
                <h2>App Summary</h2>
                <p>{app.elevatorPitch}</p>
              </div>

              {/* Features */}
              <div className="leftbottom">
                <h3>Key Features</h3>

                {app.features.map((feature, index) => (
                  <h4 key={index}>
                    {/* SVG unchanged */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                      <rect width="22" height="22" rx="11" fill="black" />
                      <path d="M11.1272 4.62012C11.4442 9.45009 16.9053 8.82242 16.9053 10.9772C16.9053 12.7339 14.3112 13.6754 11.1099 13.6754C7.90863 13.6754 5.31455 12.7339 5.31455 10.9772C5.31263 8.82242 10.7736 9.45009 11.0926 4.62012C7.39365 4.62969 4.3999 7.48098 4.3999 11.0001C4.3999 14.5193 7.40326 17.3801 11.1099 17.3801C14.8165 17.3801 17.8199 14.5231 17.8199 11.0001C17.8199 7.47715 14.8242 4.62969 11.1272 4.62012Z" fill="#E6FF00" />
                    </svg>

                    {feature}
                  </h4>
                ))}

              </div>

            </div>

            {/* RIGHT SIDE */}
            <div className="rightdetailside">

              <div className="righttop">
                <h2>Info</h2>
                <h3>Founded</h3>
                <h4>{app.founded}</h4>
                <h3>Creator</h3>
                <h4>{app.creator}</h4>
                <h3>Last updated</h3>
                <h4>{app.updated}</h4>
              </div>

              {/* Gallery */}
              <div className="gallery">

                <div className="main-image-wrapper">

                  <button className="nav left" onClick={prevSlide}>
                    <img src="/assets/left.svg" />
                  </button>

                  <img
                    src={app.images[activeIndex]}
                    className="main-image"
                  />

                  <button className="nav right" onClick={nextSlide}>
                    <img src="/assets/right.svg" />
                  </button>

                </div>

                <div className="thumbnails">
                  {app.images.map((img, index) => (
                    <img
                      key={index}
                      src={img}
                      className={`thumb ${index === activeIndex ? "active" : ""}`}
                      onClick={() => setActiveIndex(index)}
                    />
                  ))}
                </div>

              </div>

            </div>

          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default Raindetailpage;
